import { Grid } from "@material-ui/core";
import { StatCard } from "../../components/StatCard";
import {useListContext, useResourceContext} from "react-admin";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { useMemo } from "react";
import { AiOutlineFieldNumber } from "react-icons/ai";
import { TbPackages } from "react-icons/tb";
import { GiWeight } from "react-icons/gi";
import { MdOutlinePlace } from "react-icons/md";
import { TbTruckReturn } from "react-icons/tb";
import { TfiBackLeft } from "react-icons/tfi";
import { FaRepeat } from "react-icons/fa6";
import { FiPackage } from "react-icons/fi";
import { GiPathDistance } from "react-icons/gi";
import { FaClock } from "react-icons/fa";
import {useListQueryParams} from "../../shared/hooks/useListQueryParams";
import {client, getRealResource} from "../../dataProvider";
import {useQuery} from "react-query";

const formatMinutesToHHMM = (totalMinutes: number) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

export const RouteSummaryHeader = () => {

    const resource = useResourceContext();
    const query = useListQueryParams();
    const { filterValues, filter, ids } = useListContext();
    const url = `${getRealResource(resource)}/statistics`;


    const { data: stats } = useQuery(
        [url, query, filterValues, filter, ids],
        () =>
            client(url, {
                method: "GET",
                params: {
                    ...query,
                    ...filter,
                    ...filterValues,
                },
                paramsSerializer: function handleQuery(q: any) {
                    return Object.entries(q).map(([key, value], i) => Array.isArray(value) ? `${key}=${value.join('&' + key + '=')}` : `${key}=${value}`).join('&');
                }
            }),
        {
            initialData: {
                tot_packages: 0,
                tot_weight: 0,
                tot_taxable: 0,
                tot_distance: 0,
                tot_duration_minutes: 0,
                tot_deliveries: 0,
                tot_no: 0,
                tot_rc: 0,
                tot_ri: 0,
                tot_ba: 0,
                tot_ph: 0,
            },
        }
    );

    return (
        <Grid container>
            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_packages)}
                    icon={<TbPackages />}
                    subtitle="Totale colli"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_weight.toFixed(2)) + " kg"}
                    icon={<GiWeight />}
                    subtitle="Totale peso"
                />
            </Grid>

            <Grid item xs={4} sm={4}>
                <StatCard
                    label={String(stats.tot_taxable.toFixed(2)) + " €"}
                    icon={<AttachMoneyIcon />}
                    subtitle="Totale tassabile"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_distance.toFixed(0)) + " km"}
                    icon={<GiPathDistance />}
                    subtitle="Totale distanza"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={formatMinutesToHHMM(stats.tot_duration_minutes)}
                    icon={<FaClock />}
                    subtitle="Totale ore"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_deliveries)}
                    icon={<AiOutlineFieldNumber />}
                    subtitle="Totale missioni"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_no)}
                    icon={<FiPackage />}
                    subtitle="Totale consegne"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_rc)}
                    icon={<FaRepeat />}
                    subtitle="Totale riconsegne"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_ri)}
                    icon={<TbTruckReturn />}
                    subtitle="Totale ritiri"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_ba)}
                    icon={<TfiBackLeft />}
                    subtitle="Totale resi"
                />
            </Grid>

            <Grid item xs={2} sm={2}>
                <StatCard
                    label={String(stats.tot_ph)}
                    icon={<MdOutlinePlace />}
                    subtitle="Totale segnaposto"
                />
            </Grid>
        </Grid>
    );
};